import { useState } from 'react';
import { Auth } from '../services/amplifyCompat';
import { customFieldOptions } from '../constants/custom-field-options';
import { USER_TYPE } from '../utils/get-simple-user-from-attributes';


export const useCreateUser = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const getSignUpErrorMessage = (error) => {
    const errorCode = error?.name || error?.code;

    if (errorCode === 'UsernameExistsException') {
      return 'An account with the given email already exists.';
    }

    return error?.message || 'An unexpected error occurred';
  };

  const createUser = async ({email, password, preferred_username}) => {
    setSuccess(false);
    setError(null);
    setIsLoading(true);
    try {
      const normalizedEmail = email?.trim();
      const attributes = {
        preferred_username,
        name: preferred_username,
        'custom:type': USER_TYPE['MEMBER'],
        'custom:firstLogin': 'true',
        ...customFieldOptions.reduce((acc, {authFieldName}) => {
          acc[authFieldName] = ''
          return acc;
        }, {})
      }
      const { user } = await Auth.signUp({   
        username: normalizedEmail,
        password,
        attributes
      })
      setSuccess(true);
      return user;
    } catch (error) {
      console.error('Error signing up:', error);
      setError(getSignUpErrorMessage(error));
      return null;
    } finally {
      setIsLoading(false);
    }
  }

  return { createUser, isLoading, error, success}
}
